// Configurazione API
const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001',
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001', // Compatibilità per TabContratti
  endpoints: {
    pratiche: '/api/pratica',  // Endpoint corretto nel backend
    clienti: '/api/clienti',
    auth: '/api/auth',
    agenzie: '/api/agenzie',
    agenti: '/api/utenti/agenti',
    offerte: '/api/offerte-public',
    vetture: '/api/vetture'
  }
};

export default API_CONFIG; 